import React from 'react'

import SocialLinks from './SocialLinks'

export default function ConsoleFooter({ ipfsInfo = {}, projectName = '', t = (key) => key }) {
    const displayName = String(projectName || ipfsInfo.project_name || t('质押挖矿')).trim()

    return <footer className="console-footer">
        <SocialLinks ipfsInfo={ipfsInfo} t={t} />
        <div className="console-footer__copyright">
            <span>© 2026</span>
            <strong>{displayName}</strong>
        </div>
    </footer>
}
